import axios from 'axios';
import {TripData} from './trips-api';

const baseURL = import.meta.env.VITE_API_BASE_URL;

const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export async function getTrip(
  tripKey: string,
  vehicleKey: string
): Promise<TripData> {
  const {data: trip} = await api.get<TripData>(
    `/api/special-purpose/v1/vehicle/${vehicleKey}/trip/${tripKey}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return trip;
}

export async function getTrips(
  vehicleKey: string,
  options: {
    size?: number;
    startedAfter?: string;
    startedBefore?: string;
  }
) {
  const params = {
    size: options.size || 200,
  } as {
    size?: number;
    started_after?: string;
    started_before?: string;
  };

  if (options.startedAfter) {
    params.started_after = options.startedAfter;
  }

  if (options.startedBefore) {
    params.started_before = options.startedBefore;
  }

  const response = await api.get<{trips: TripData[]}>(
    `/api/special-purpose/v1/vehicle/${vehicleKey}/trips`,
    {
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const {
    data: {trips},
  } = response;

  return trips;
}

let accessToken: string;
export function setApiToken(token: string) {
  accessToken = token;
}
